import { render, staticRenderFns } from "./VideoDetail.vue?vue&type=template&id=6105a894&scoped=true&lang=pug"
import script from "./VideoDetail.vue?vue&type=script&lang=js"
export * from "./VideoDetail.vue?vue&type=script&lang=js"
import style0 from "./VideoDetail.vue?vue&type=style&index=0&id=6105a894&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6105a894",
  null
  
)

export default component.exports